import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit {
  @Input() isCondensed = false;

  menuItems = [];

  constructor(private route: ActivatedRoute, private router: Router) {
    router.events.subscribe((val) => {
      let menus = document.querySelectorAll(".sub-menu-list") as any;
      if (document.body.classList.contains("sidebarclass")) {
        menus.forEach((element) => {
          element.style.display = "none";
        });
      }
    });
  }

  ngOnInit() {}

  show() {
    var popup = document.getElementsByClassName("menu-item");
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling?.classList.toggle("mm-show");
  }

  Doctors(event) {
    let matchElement = event.target.closest(".has-child");
    let element = matchElement?.nextElementSibling;
    if ((element?.style?.display as any) === "none") {
      element.style.display = "block";
    } else {
      if (element) {
        element.style.display = "none";
      }
    }
  }
}
